<template>
  <div>
    <basehead />
    <IrealDetail :identifier="$route.params.identifier"></IrealDetail>
  </div>
</template>

<script>
import IrealVue from "ireal-vue";
import basehead from "@/components/basehead.vue";

export default {
  name: "detail",
  components: {
    IrealDetail: IrealVue.IrealDetail,
    basehead
  }
};
</script>
